var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg01AiGuardrails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300 190",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #6f7274;\n      }\n\n      .cls-3 {\n        fill: #646668;\n      }\n\n      .cls-4 {\n        mix-blend-mode: multiply;\n        opacity: .3;\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-12 {\n        fill: #f6f6e0;\n      }\n\n      .cls-13 {\n        fill: #bfbe91;\n      }\n\n      .cls-14 {\n        fill: #6e7173;\n      }\n\n      .cls-15 {\n        fill: #7ab5fc;\n      }\n\n      .cls-16 {\n        fill: #323142;\n      }\n\n      .cls-17 {\n        fill: #5c98e0;\n      }\n\n      .cls-18 {\n        fill: #6c6f71;\n      }\n\n      .cls-19 {\n        fill: #67696b;\n      }\n\n      .cls-20 {\n        fill: #bcd1eb;\n      }\n\n      .cls-21 {\n        fill: #bbc0c4;\n      }\n\n      .cls-22 {\n        fill: #a5bfe1;\n      }\n\n      .cls-23 {\n        fill: #c7d9f0;\n      }\n\n      .cls-24 {\n        fill: #6a6d6f;\n      }\n\n      .cls-25 {\n        fill: #373647;\n      }\n\n      .cls-26 {\n        fill: #e1ecf6;\n      }\n\n      .cls-27 {\n        fill: #3e2690;\n      }\n\n      .cls-28 {\n        fill: #cecbab;\n      }\n\n      .cls-29 {\n        isolation: isolate;\n      }\n\n      .cls-30, .cls-31 {\n        fill: #d9e8fa;\n      }\n\n      .cls-32 {\n        fill: #afb4b8;\n      }\n\n      .cls-33 {\n        fill: #85c18b;\n      }\n\n      .cls-34 {\n        fill: #aaa883;\n      }\n\n      .cls-35 {\n        fill: #2161df;\n      }\n\n      .cls-36 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-37 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-38 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-39 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-40 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-41 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-41, .cls-31 {\n        opacity: .25;\n      }\n\n      .cls-42 {\n        fill: url(#linear-gradient);\n        opacity: .35;\n      }\n\n      .cls-43 {\n        fill: #bec3c7;\n      }\n\n      .cls-44 {\n        fill: #fff;\n      }\n\n      .cls-45 {\n        fill: #1766d6;\n      }\n\n      .cls-46 {\n        fill: #3f3e4e;\n      }\n\n      .cls-47 {\n        fill: #ffb25f;\n      }\n\n      .cls-48 {\n        fill: #ddd7b6;\n      }\n\n      .cls-49 {\n        fill: #acb2b6;\n      }\n\n      .cls-50 {\n        fill: #1860d3;\n      }\n\n      .cls-51 {\n        fill: #bcc1c4;\n      }\n\n      .cls-52 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-53 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-54 {\n        fill: #4c8353;\n      }\n\n      .cls-55 {\n        opacity: .2;\n      }\n\n      .cls-56 {\n        fill: #d1d4d6;\n      }\n\n      .cls-57 {\n        fill: #7cd3db;\n      }\n\n      .cls-58 {\n        fill: #aee5b4;\n      }\n\n      .cls-59 {\n        fill: #aab0b5;\n      }\n\n      .cls-60 {\n        fill: #75787b;\n      }\n\n      .cls-61 {\n        fill: #5590e4;\n      }\n\n      .cls-62 {\n        fill: #1f5e24;\n      }\n\n      .cls-63 {\n        fill: #636567;\n      }\n\n      .cls-64 {\n        fill: #f8ce0e;\n      }\n\n      .cls-65 {\n        fill: #45435e;\n      }\n\n      .cls-66 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 17413.97,
    y1: 42.79,
    x2: 17489.54,
    y2: 86.43,
    gradientTransform: "translate(17580.28) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2161df"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 17397.15,
    y1: 71.15,
    x2: 17470.63,
    y2: 113.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.75,157.96v.84c0,.11-.05.23-.17.33v-.84c.11-.1.17-.22.17-.33Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.53,161.72v-.84c0,.2.16.39.47.51v.84c-.3-.12-.47-.31-.47-.51Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.16,162.28v.84c-.31.28-.95.36-1.42.17v-.84c.47.18,1.11.1,1.42-.17Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -16798.62,
    y1: -33646.2,
    x2: -16796.71,
    y2: -33646.2,
    gradientTransform: "translate(14558.54 2638.93) rotate(-65.89) scale(.93 .42) skewX(-20.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#afb4b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#bec3c7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -12002.36,
    y1: 151.08,
    x2: -11994.95,
    y2: 151.08,
    gradientTransform: "translate(12070.57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#afb4b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#d8dbdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#dde0e2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -12003.27,
    y1: 130.8,
    x2: -11993.67,
    y2: 130.8,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.32,165.73v.85c0,.22-.21.43-.57.53v-.85c.36-.1.57-.31.57-.53Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.57,166.95v-.85c0,.09.04.18.11.27v.85c-.08-.09-.11-.18-.11-.27Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.54,168.35v.85c-.51.15-1.13.03-1.38-.27v-.85c.26.29.88.41,1.38.27Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -16121.63,
    y1: -27165.07,
    x2: -16119.72,
    y2: -27165.07,
    gradientTransform: "translate(14755.42 2794.96) rotate(-53.98) scale(.9 .49) skewX(-18.15)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -11991.2,
    y1: 155.5,
    x2: -11984.37,
    y2: 155.5,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -11999.04,
    y1: 133.66,
    x2: -11984.07,
    y2: 133.66,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -12005.67,
    y1: 107.85,
    x2: -11986.6,
    y2: 107.85,
    gradientTransform: "translate(12070.57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#9fa6ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#a9afb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#bfc3c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#cccfd2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#d1d4d6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -11983.69,
    y1: 110.56,
    x2: -11980.61,
    y2: 104.37,
    gradientTransform: "translate(12070.57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#afb4b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cdd1d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#dde0e2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -11970.51,
    y1: 108.99,
    x2: -11974.19,
    y2: 106.54,
    xlinkHref: "#linear-gradient-10"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: -1.64,
    y: -1.2,
    width: 303.28,
    height: 192.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-48",
    cx: 143.6,
    cy: 164.66,
    rx: 86.92,
    ry: 25
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M125.32,9.42v50.8s15.95-8.69,39.93-1.97c4.18,1.17,8.61,2.81,13.24,5.05,6.26,3.02,11.39,6.6,15.58,10.37,16.67,15.01,18.55,33.25,18.55,33.25v-50.8s-2.94-28.57-34.12-43.62c-31.18-15.05-53.17-3.07-53.17-3.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M120.84,16.32v50.8s15.95-8.69,39.93-1.97c4.18,1.17,8.61,2.81,13.24,5.05,6.26,3.02,11.39,6.6,15.58,10.37,16.67,15.01,18.55,33.25,18.55,33.25v-50.8s-2.94-28.57-34.12-43.62c-31.18-15.05-53.17-3.07-53.17-3.07Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "179.51 62.18 177.23 60.97 177.16 58.49 179.43 59.7 179.51 62.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "179.61 65.58 177.33 64.37 177.26 61.88 179.53 63.09 179.61 65.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "179.71 68.97 177.43 67.76 177.36 65.28 179.63 66.49 179.71 68.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "194.99 70.43 180.6 62.76 180.53 60.28 194.92 67.95 194.99 70.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "195.09 73.83 180.7 66.16 180.63 63.68 195.02 71.34 195.09 73.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "195.19 77.22 180.8 69.55 180.73 67.07 195.12 74.74 195.19 77.22"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M128.89,41.44l.23,7.77.35,11.8.23,7.77,39.27,20.92-.23-7.77-.35-11.8-.23-7.77-.03-.02-39.14-20.85-.1-.05ZM129.6,61.09l3.43,1.83.11,3.74-3.43-1.83-.11-3.74ZM168.15,66.18l-3.43-1.83-.11-3.74,3.43,1.83.11,3.74ZM129.03,41.66l3.43,1.83.11,3.74-3.43-1.83-.11-3.74ZM150.48,60.73l.11,3.74-3.43-1.83-.11-3.74,3.43,1.83ZM147.27,66.53l-.11-3.74,3.43,1.83.11,3.74-3.43-1.83ZM154.15,66.51l.11,3.74-3.43-1.83-.11-3.74,3.43,1.83ZM143.72,64.64l-.11-3.74,3.43,1.83.11,3.74-3.43-1.83ZM143.6,60.75l-.11-3.74,3.43,1.83.11,3.74-3.43-1.83ZM154.03,62.63l.11,3.74-3.43-1.83-.11-3.74,3.43,1.83ZM157.71,68.41l.11,3.74-3.43-1.83-.11-3.74,3.43,1.83ZM157.82,72.3l.11,3.74-3.43-1.83-.11-3.74,3.43,1.83ZM154.37,74.14l-3.43-1.83-.11-3.74,3.43,1.83.11,3.74ZM150.81,72.25l-3.43-1.83-.11-3.74,3.43,1.83.11,3.74ZM147.26,70.35l-3.43-1.83-.11-3.74,3.43,1.83.11,3.74ZM140.16,62.74l-.11-3.74,3.43,1.83.11,3.74-3.43-1.83ZM140.04,58.86l-.11-3.74,3.43,1.83.11,3.74-3.43-1.83ZM157.59,64.52l.11,3.74-3.43-1.83-.11-3.74,3.43,1.83ZM161.26,70.31l.11,3.74-3.43-1.83-.11-3.74,3.43,1.83ZM161.38,74.19l.11,3.74-3.43-1.83-.11-3.74,3.43,1.83ZM140.27,66.63l-.11-3.74,3.43,1.83.11,3.74-3.43-1.83ZM136.6,60.85l-.11-3.74,3.43,1.83.11,3.74-3.43-1.83ZM136.49,56.96l-.11-3.74,3.43,1.83.11,3.74-3.43-1.83ZM139.93,54.97l-.11-3.74,3.43,1.83.11,3.74-3.43-1.83ZM143.38,53.13l3.43,1.83.11,3.74-3.43-1.83-.11-3.74ZM146.94,55.02l3.43,1.83.11,3.74-3.43-1.83-.11-3.74ZM150.49,56.92l3.43,1.83.11,3.74-3.43-1.83-.11-3.74ZM154.05,58.81l3.43,1.83.11,3.74-3.43-1.83-.11-3.74ZM157.61,60.71l3.43,1.83.11,3.74-3.43-1.83-.11-3.74ZM161.15,66.42l.11,3.74-3.43-1.83-.11-3.74,3.43,1.83ZM164.82,72.2l.11,3.74-3.43-1.83-.11-3.74,3.43,1.83ZM164.94,76.09l.11,3.74-3.43-1.83-.11-3.74,3.43,1.83ZM136.71,64.73l-.11-3.74,3.43,1.83.11,3.74-3.43-1.83ZM133.04,58.95l-.11-3.74,3.43,1.83.11,3.74-3.43-1.83ZM132.93,55.07l-.11-3.74,3.43,1.83.11,3.74-3.43-1.83ZM136.37,53.08l-.11-3.74,3.43,1.83.11,3.74-3.43-1.83ZM136.26,49.19l-.11-3.74,3.43,1.83.11,3.74-3.43-1.83ZM139.71,47.34l3.43,1.83.11,3.74-3.43-1.83-.11-3.74ZM143.26,49.24l3.43,1.83.11,3.74-3.43-1.83-.11-3.74ZM146.82,51.14l3.43,1.83.11,3.74-3.43-1.83-.11-3.74ZM150.38,53.03l3.43,1.83.11,3.74-3.43-1.83-.11-3.74ZM153.94,54.93l3.43,1.83.11,3.74-3.43-1.83-.11-3.74ZM157.5,56.82l3.43,1.83.11,3.74-3.43-1.83-.11-3.74ZM161.06,58.72l3.43,1.83.11,3.74-3.43-1.83-.11-3.74ZM164.6,64.43l.11,3.74-3.43-1.83-.11-3.74,3.43,1.83ZM164.71,68.32l.11,3.74-3.43-1.83-.11-3.74,3.43,1.83ZM168.38,74.1l.11,3.74-3.43-1.83-.11-3.74,3.43,1.83ZM168.6,81.72l-3.43-1.83-.11-3.74,3.43,1.83.11,3.74ZM161.49,78.08l.11,3.74-3.43-1.83-.11-3.74,3.43,1.83ZM158.04,79.92l-3.43-1.83-.11-3.74,3.43,1.83.11,3.74ZM154.49,78.03l-3.43-1.83-.11-3.74,3.43,1.83.11,3.74ZM150.93,76.13l-3.43-1.83-.11-3.74,3.43,1.83.11,3.74ZM147.37,74.24l-3.43-1.83-.11-3.74,3.43,1.83.11,3.74ZM143.81,72.34l-3.43-1.83-.11-3.74,3.43,1.83.11,3.74ZM140.25,70.44l-3.43-1.83-.11-3.74,3.43,1.83.11,3.74ZM133.15,62.84l-.11-3.74,3.43,1.83.11,3.74-3.43-1.83ZM129.48,57.06l-.11-3.74,3.43,1.83.11,3.74-3.43-1.83ZM129.37,53.17l-.11-3.74,3.43,1.83.11,3.74-3.43-1.83ZM132.81,51.18l-.11-3.74,3.43,1.83.11,3.74-3.43-1.83ZM132.7,47.29l-.11-3.74,3.43,1.83.11,3.74-3.43-1.83ZM168.26,70.07l-3.43-1.83-.11-3.74,3.43,1.83.11,3.74ZM168.38,73.95l-3.43-1.83-.11-3.74,3.43,1.83.11,3.74ZM168.72,85.61l-3.43-1.83-.11-3.74,3.43,1.83.11,3.74ZM165.16,83.71l-3.43-1.83-.11-3.74,3.43,1.83.11,3.74ZM165.17,83.86l.11,3.74-3.43-1.83-.11-3.74,3.43,1.83ZM161.72,85.7l-3.43-1.83-.11-3.74,3.43,1.83.11,3.74ZM158.16,83.81l-3.43-1.83-.11-3.74,3.43,1.83.11,3.74ZM154.6,81.91l-3.43-1.83-.11-3.74,3.43,1.83.11,3.74ZM151.04,80.02l-3.43-1.83-.11-3.74,3.43,1.83.11,3.74ZM147.48,78.12l-3.43-1.83-.11-3.74,3.43,1.83.11,3.74ZM143.93,76.23l-3.43-1.83-.11-3.74,3.43,1.83.11,3.74ZM140.37,74.33l-3.43-1.83-.11-3.74,3.43,1.83.11,3.74ZM136.81,72.43l-3.43-1.83-.11-3.74,3.43,1.83.11,3.74ZM133.27,66.72l-.11-3.74,3.43,1.83.11,3.74-3.43-1.83ZM129.49,57.2l3.43,1.83.11,3.74-3.43-1.83-.11-3.74ZM129.15,45.54l3.43,1.83.11,3.74-3.43-1.83-.11-3.74ZM168.83,89.5l-3.43-1.83-.11-3.74,3.43,1.83.11,3.74ZM129.82,68.71l-.11-3.74,3.43,1.83.11,3.74-3.43-1.83Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M167.94,77.7s.07,0,.1-.02c.13-.06.18-.21.12-.33-.26-.53-2.6-5.2-3.91-5.94-.7-.39-1.32.19-1.87.71-.56.53-.92.83-1.26.63-1.32-.78-2.58-3.62-3.8-6.37-1.31-2.94-2.54-5.72-4-6.6-.79-.47-1.51.18-2.15.76-.65.58-1.1.95-1.52.71-.83-.48-1.55-2.34-2.31-4.3-1.12-2.9-2.39-6.19-4.64-7.02-1.48-.55-2.75-.29-3.89.77-.96.9-1.68,2.24-2.37,3.53-1.3,2.42-2.19,3.84-3.68,3.21-1.07-.46-2.31-2.99-2.69-3.93-.05-.13-.2-.19-.34-.14-.13.05-.2.19-.15.32.06.15,1.48,3.57,2.97,4.21.93.4,1.76.19,2.55-.63.66-.68,1.21-1.71,1.79-2.81,1.35-2.52,2.75-5.13,5.62-4.08,2.02.75,3.25,3.92,4.33,6.72.83,2.14,1.54,3.99,2.53,4.56.78.45,1.5-.2,2.14-.77.67-.6,1.11-.95,1.53-.7,1.32.79,2.58,3.63,3.8,6.37,1.31,2.95,2.55,5.73,4.01,6.6.71.42,1.34-.17,1.89-.7.54-.51.91-.82,1.25-.64.99.55,3,4.31,3.7,5.71.05.09.14.15.24.15Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "158.82 84.16 165.15 87.53 164.82 76.57 158.5 73.2 158.82 84.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "149.33 79.1 155.66 82.47 155.18 66.1 148.85 62.73 149.33 79.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "130.35 68.99 136.67 72.36 136.38 62.16 130.05 58.79 130.35 68.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "139.84 74.05 146.16 77.42 145.56 56.61 139.23 53.24 139.84 74.05"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M132.34,18.96l-2.79.81c2.21,4.22,5.65,8.03,9.45,10.05l-.11-3.91c-2.63-1.4-5.01-4.04-6.55-6.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M146.17,24.44c-1.11,2.55-3.93,3.27-7.28,1.48l.11,3.91c4.85,2.58,8.91,1.54,10.52-2.14l-3.35-3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M138.37,8.34l-.11-3.91c-4.85-2.58-8.91-1.54-10.52,2.14l3.35,3.25c1.11-2.55,3.93-3.27,7.28-1.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M130.58,12.84c-.03-1.18.15-2.2.51-3.02l-3.35-3.25c-.52,1.19-.78,2.65-.73,4.36.08,2.85,1.02,5.94,2.54,8.84l2.79-.81c-1.05-2.01-1.7-4.15-1.76-6.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M144.92,15.3l2.79-.81c-2.21-4.22-5.65-8.03-9.45-10.05l.11,3.91c2.63,1.4,5.01,4.04,6.55,6.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M146.68,21.42c.03,1.18-.15,2.2-.51,3.02l3.35,3.25c.52-1.19.78-2.65.73-4.36-.08-2.85-1.02-5.94-2.54-8.84l-2.79.81c1.05,2.01,1.7,4.15,1.76,6.12Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M188.18,60.52l-.04-.02-33.85-18.03-.45-15.45.04.02,33.85,18.03.45,15.45ZM154.33,42.44l33.79,18-.45-15.34-33.79-18,.45,15.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "187.76 47.68 153.92 29.65 153.95 29.61 187.79 47.64 187.76 47.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "187.84 50.24 154 32.21 154.02 32.17 187.86 50.2 187.84 50.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "187.91 52.81 154.07 34.78 154.1 34.74 187.94 52.77 187.91 52.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "187.99 55.37 154.15 37.35 154.17 37.3 188.01 55.33 187.99 55.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "188.06 57.94 154.22 39.91 154.25 39.87 188.09 57.9 188.06 57.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "184.79 58.68 184.74 58.68 184.29 43.29 184.34 43.29 184.79 58.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "181.41 56.88 181.36 56.88 180.91 41.49 180.96 41.48 181.41 56.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "178.02 55.08 177.97 55.08 177.52 39.68 177.57 39.68 178.02 55.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "174.64 53.27 174.59 53.27 174.14 37.88 174.19 37.88 174.64 53.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "171.25 51.47 171.21 51.47 170.76 36.08 170.8 36.08 171.25 51.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "167.87 49.67 167.82 49.67 167.37 34.27 167.42 34.27 167.87 49.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "164.49 47.86 164.44 47.87 163.99 32.47 164.04 32.47 164.49 47.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "161.1 46.06 161.05 46.06 160.6 30.67 160.65 30.67 161.1 46.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "157.72 44.26 157.67 44.26 157.22 28.87 157.27 28.86 157.72 44.26"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "157.69 44.26 154.31 42.46 153.93 29.63 157.32 31.43 157.69 44.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "162.77 46.96 159.39 45.16 159.16 37.42 162.54 39.22 162.77 46.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "183.07 57.78 179.69 55.98 179.46 48.24 182.85 50.04 183.07 57.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "172.92 52.37 169.54 50.57 169.46 47.77 172.84 49.57 172.92 52.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "188.15 60.48 184.77 58.68 184.58 52.27 187.96 54.07 188.15 60.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "167.85 49.67 164.46 47.87 164.16 37.59 167.55 39.39 167.85 49.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "178 55.08 174.61 53.27 174.21 39.59 177.6 41.4 178 55.08"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M186.13,82.47l-3.59,5.16c-3.7-4.23-5.1-9.97-3.11-12.82,1.32-1.9,3.66-2.13,6.46-.64l.24,8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M186.13,82.47l4.01,9.21c-2.38.24-5.13-1.23-7.6-4.05l3.59-5.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M186.13,82.47l3.59-5.16c3.7,4.23,5.1,9.97,3.11,12.82-.66.95-1.5,1.44-2.69,1.56l-4.01-9.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M186.13,82.47l-.24-8.3c1.4.74,2.6,1.73,3.83,3.14l-3.59,5.16Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "72.27 80.07 136.7 25.14 199.52 58.38 83.62 87.67 72.27 80.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "83.62 87.67 84.06 94.17 200.64 101.99 199.37 58.52 83.62 87.67"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "67.22 86.95 67.77 87.27 69.01 79.03 68.46 78.72 67.73 79.14 67.22 86.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "67.77 87.27 69.01 86.55 69.01 79.03 68.28 79.45 67.77 87.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M67.11,85.68c.71-1.22,1.85-1.88,2.56-1.48l.55.32-.12.21c.23.6.09,1.53-.42,2.41-.51.88-1.25,1.47-1.89,1.58l-.13.22-.55-.32c-.71-.4-.71-1.72,0-2.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M67.65,86c-.71,1.22-.71,2.54,0,2.94.71.4,1.85-.26,2.56-1.48.71-1.22.71-2.54,0-2.94-.71-.4-1.85.26-2.56,1.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M67.99,86.19c-.52.9-.52,1.88,0,2.18.52.3,1.37-.19,1.9-1.1.52-.9.52-1.88,0-2.18-.52-.3-1.37.19-1.9,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M67.86,87.35c0,.68.48.96,1.08.61.59-.34,1.08-1.17,1.08-1.86s-.48-.96-1.08-.61c-.59.34-1.08,1.17-1.08,1.86Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M68.31,122.29s-.41-.08-.54.12.44,1.28.44,1.28c0,0,.64.76.86.86.22.11.67-.34.63-.55-.04-.21-1.1-1.2-1.1-1.2l-.29-.5Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-66"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M76.75,157.96v.84c0,.09-.03.17-.1.25v-.84c.06-.08.1-.17.1-.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M76.66,158.22v.84s-.04.05-.07.08v-.84s.05-.05.07-.08h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M67.99,161.39v.84s-.09-.04-.13-.06v-.84s.08.04.13.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M67.87,161.33v.84c-.22-.12-.34-.28-.34-.45v-.84c0,.17.12.33.34.45h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "76.58 158.29 76.58 159.13 72.16 163.11 72.16 162.28 76.58 158.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "70.74 162.45 70.74 163.29 67.99 162.23 67.99 161.39 70.74 162.45"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M72.16,162.28v.84s-.09.07-.14.1v-.84c.05-.03.1-.06.14-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M72.02,162.38v.84c-.29.16-.71.22-1.09.13v-.84c.37.09.8.03,1.09-.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M70.93,162.51v.84c-.07-.02-.13-.03-.19-.06v-.84c.06.02.12.04.19.06h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M76.29,157.46c.47.18.61.56.3.84l-4.42,3.98c-.31.28-.95.36-1.42.17l-2.75-1.06c-.47-.18-.61-.56-.3-.84l4.42-3.98c.31-.28.95-.36,1.42-.18l2.75,1.06Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M69.21,158.93c.22.29.12.94-.24,1.45-.35.51-.82.68-1.04.39-.22-.29-.12-.94.24-1.45.35-.51.82-.68,1.04-.39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "68.09 160.91 71.29 162.17 72.25 160.1 69.07 158.82 68.09 160.91"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M72.39,160.21c.22.29.12.94-.24,1.45-.35.51-.82.68-1.04.39-.22-.29-.12-.94.24-1.45.35-.51.82-.68,1.04-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M72.2,160.49c.15.2.08.65-.16,1-.24.35-.57.47-.72.27-.15-.2-.08-.65.16-1,.24-.35.57-.47.72-.27Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M71.53,141.61c-2.4.4-3.11,4.85-3.24,7.05-.13,2.2-.08,9.3-.04,10.69.03,1.4,2.18,1.46,2.83.91.75-.64.97-1.35.97-1.35,0,0,3.69-13.51,3.56-15.6-.13-2.09-4.08-1.7-4.08-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M75.62,143.45c.03.79-.52,1.17-1.67,1.38-1.49.27-4.66-.67-4.06-2.07.72-1.66,5.73.7,5.73.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M75.77,143.38c-.4,1.44-3.37,1.26-4.08.93-.7-.33-1.35-.48-1.71-1.2-.36-.73.22-3.56-.15-4.99-.36-1.43-1.6-6.3-2.13-8.78-.52-2.48-.6-6.91.12-9.65.72-2.74,4.98-2.61,4.98-2.61,0,0,2.46-.19,3.69,5.53,1.23,5.72-.73,20.78-.73,20.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M70.44,120.41c-.27,3.89-.43,7.39.12,8.64.56,1.25,3.57,1.96,3.57,1.96,0,0,.63-9.18-3.69-10.6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M88.32,89.83c-.31-1.17-.35-1.85-.88-1.87-.53-.01-1.46,1.61-1.69,2.03-.23.42-.33,2.78.35,3,.68.22,2.25-1.22,2.25-1.87,0-.64-.02-1.3-.02-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M90.62,90.31c-.47.02-1.98.14-2.2.31-.22.17-.32.2-.33.51-.01.31-.21.62.35.54.56-.07,2.1-.58,2.25-.89.15-.31-.06-.47-.06-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M91.09,88.55c-.16-.14-1.63.32-1.98.45-.35.12-.75.19-.82.48-.06.3.06.77.23.74s1.16-.64,1.16-.64c0,0,1.48-.35,1.52-.56.04-.21-.12-.47-.12-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M91.13,87.45c-.49-.34-1.92.2-2.25.35-.33.15-1.12.48-1.2.84-.07.36-.23,1.05.25,1.04.48-.01,1.58-1.19,1.58-1.19,0,0,1.67-.31,1.71-.49s.07-.43-.09-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M90.29,86.22c.16.27-.09.48-.3.62-.21.14-1.16.58-1.31.67-.15.09-.69,1.29-1.05,1.56-.36.27-1.01-.06-.87-.38.15-.32.75-1.27,1.11-1.51.36-.23,1.31-.85,1.51-.91.2-.06.8-.23.9-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M86.35,89.99c-1.3.06-7.92,3.21-8.77,3.47-.85.26-1.69,3.45.54,3.6,2.23.15,7.95-4.19,8.23-4.52.28-.33,1.35-1.95,0-2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M75.28,95.34s1.61.35-1.51-.52c-3.12-.87-4.03-1.41-6.16-1.24-2.13.17-3.35,2.3-3.55,4.03-.2,1.73.94,3.3,3.41,4.91,2.47,1.61,7.8-7.18,7.8-7.18Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M90.32,165.73v.85c0,.09-.03.17-.09.25v-.85c.06-.08.09-.16.09-.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M90.23,165.98v.85c-.05.06-.12.12-.2.17v-.85c.08-.05.15-.11.2-.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M90.03,166.14v.85c-.08.05-.17.09-.28.12v-.85c.11-.03.2-.07.28-.12h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M79.68,166.38v.85c-.08-.09-.11-.18-.11-.27v-.85c0,.09.04.18.11.27h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "81.16 168.08 81.16 168.93 79.68 167.22 79.68 166.38 81.16 168.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "89.75 166.26 89.75 167.11 82.54 169.19 82.54 168.35 89.75 166.26"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M82.54,168.35v.85c-.07.02-.14.03-.21.05v-.85c.07-.01.14-.03.21-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M82.33,168.39v.85s-.08.01-.12.01v-.85s.08,0,.12-.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M82.21,168.4v.85c-.19.01-.39,0-.56-.05v-.85c.18.05.37.06.56.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M81.65,168.35v.85c-.11-.03-.2-.07-.29-.11v-.85c.09.05.18.09.29.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M81.36,168.24v.85c-.08-.05-.15-.1-.2-.16v-.85c.06.06.12.12.2.16h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M90.21,165.46c.25.29.05.65-.46.8l-7.21,2.08c-.51.15-1.13.03-1.38-.27l-1.47-1.7c-.25-.29-.05-.65.46-.8l7.21-2.08c.51-.15,1.13-.03,1.38.27l1.47,1.7Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M81.39,164.45c.17.3-.03.89-.45,1.32-.42.43-.9.53-1.07.22-.17-.3.03-.89.45-1.32s.9-.53,1.07-.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "79.86 166 81.75 168.13 83.28 166.59 81.39 164.45 79.86 166"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M83.35,166.62c.23.33.04.93-.43,1.33-.46.41-1.02.47-1.24.15-.23-.33-.04-.93.43-1.33.46-.41,1.02-.47,1.24-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M83.09,166.85c.16.23.02.64-.29.92-.32.28-.7.33-.86.1-.16-.23-.02-.64.29-.92.32-.28.7-.33.86-.1Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M84.04,164.16c-.06,1.43-.55,2.25-1.73,2.55-1.18.3-2.23.04-2.3-.43-.07-.47.23-7.84-.37-11.98-.6-4.15-.05-7.66.75-8.97.79-1.32,5.35-1.27,5.61-1.04.26.24.38,5.92-.2,9.3-.59,3.38-1.75,10.57-1.75,10.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M86.17,145.78c.03,1.01-3.16,2.68-4.46,2.83-1.3.15-2.07-.73-2.01-1.29.06-.56.75-1.84.75-1.84l5.72.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M84.24,147.27c-1.77,1.05-3.03,1.57-4.14.32-1.12-1.25-2-10.96-3.06-12.59-1.06-1.62-3.78-2.67-4.64-5.88-.85-3.21-1.18-5.2-.53-7.42.65-2.23,9.48-3.91,10.79-1.56,1.31,2.34,3.49,10.27,3.74,14.19.25,3.92-.06,10.62-.24,11.46-.18.85-1.93,1.49-1.93,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M76.38,113.57l6.07,2.31v4.01c0,1.06-.57,2.04-1.49,2.57l-2.42,1.15c-1.34.77-2.99.77-4.33,0l-4.15-2.15c-.78-.45-1.26-1.29-1.26-2.19v-.12c0-.75.4-1.44,1.05-1.81l6.54-3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M83.28,111.71c.22,7.4-.19,6.4-.83,7.2-.37.46-2.56,1.59-4.35,2.46-1.52.75-3.32.67-4.77-.2l-2.33-1.31c-1.93-1.16-3.33-2.51-3.88-4.67-.01-.04-.02-.09-.04-.14,0,0-2.1-12.23-2.18-16-.07-3.76,3.6-5.36,5.24-5.2,1.67.16,5.05,1.9,7.48,2.63,1.79.54,4.31,1.82,5.56,2.76h0c.45.34.73.64.76.83.1.75-.68,11.65-.68,11.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M83.28,111.71c.22,7.4-.19,6.4-.83,7.2-.37.46-2.56,1.59-4.35,2.46-1.52.75-3.32.67-4.77-.2l-2.33-1.31c-1.93-1.16-3.33-2.51-3.88-4.67,3.14,5.7,9.62,5.83,10.65,5.03,3.36-2.6.5-9.87.04-14.95-.45-5.07,2.69-6.86,5.38-6.03h0c.45.34.73.64.76.83.1.75-.68,11.65-.68,11.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M81.85,99.61c-1.57-.07-2.67,1.21-2.85,2.98-.18,1.77.76,3.99,2.85,3.72,2.09-.27,0-6.71,0-6.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M71.46,92.11c-.16,1.86-.1,4.2-.1,4.2,0,0,1.73,1.42,3.27,1.69,2.87.5,3.64-.35,3.64-.35,0,0,.37-2.36.53-3.17.16-.81.45-4.13.45-4.13,0,0-1.36-3.46-3.39-3.32-2.03.14-4.39,5.09-4.39,5.09Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M68.26,92.68c-.39-.34-.77-.69-1.16-1.03-.2-.18-.34-.44-.41-.78l1.12.95c.07.38.23.66.45.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M74.2,79.19c.48.18.96.36,1.45.55-.53-.2-1.24-.03-1.96.53l-1.28-.59c.66-.51,1.31-.67,1.79-.48Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "67.81 91.82 66.7 90.87 65.96 87.18 67.08 88.13 67.81 91.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "68.92 83.99 67.64 83.4 72.41 79.67 73.69 80.26 68.92 83.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M74.17,96.27l-5.74-3.47c-.3-.18-.53-.51-.62-.98l5.74,3.47c.09.47.31.8.62.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M67.08,88.13l-1.12-.95c-.23-1.18.52-2.87,1.68-3.78l1.28.59c-1.27.99-2.09,2.84-1.83,4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M75.8,96.9c-.48-.18-.96-.36-1.44-.54-.4-.15-.7-.51-.81-1.07l1.52.64c.1.51.37.84.73.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M75.84,79.83l5.74,3.47c-.54-.33-1.34-.19-2.15.44l-5.74-3.47c.81-.63,1.61-.76,2.15-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M81.74,83.41c.38.34.77.68,1.16,1.03-.48-.43-1.29-.35-2.11.29l-1.36-1c.9-.7,1.78-.79,2.31-.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "73.55 95.29 67.81 91.82 67.08 88.13 72.82 91.6 73.55 95.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "74.65 87.46 68.92 83.99 73.69 80.26 79.42 83.73 74.65 87.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "75.06 95.92 73.55 95.29 72.82 91.6 74.33 92.24 75.06 95.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M72.82,91.6l-5.74-3.47c-.26-1.29.57-3.14,1.83-4.14l5.74,3.47c-1.27.99-2.09,2.84-1.83,4.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "76.01 88.46 74.65 87.46 79.42 83.73 80.78 84.73 76.01 88.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M80.78,84.73c1.16-.91,2.29-.68,2.53.5l1.3,6.52c.16.82-.36,2.01-1.17,2.64l-1.61,1.25-4.18.74c-1.21.95-2.34.73-2.58-.45l-.73-3.69c-.23-1.18.52-2.87,1.68-3.78l4.77-3.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M74.33,92.24l-1.52-.64c-.26-1.29.57-3.14,1.83-4.14l1.36,1c-1.16.91-1.91,2.6-1.68,3.78Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M71.31,80.52l2.33-1.92c.15-.12.4-.1.73.09l-2.33,1.92c-.32-.19-.58-.21-.73-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M84.49,91.41l-2.33,1.92c.11-.09.16-.28.11-.53l2.33-1.92c.05.26,0,.44-.11.53Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "81.03 86.73 83.36 84.8 84.59 90.88 82.26 92.8 81.03 86.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "72.04 80.61 74.36 78.68 82.1 83.15 79.77 85.07 72.04 80.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M79.77,85.07l2.33-1.92c.58.33,1.14,1.07,1.26,1.65l-2.33,1.92c-.12-.58-.68-1.32-1.26-1.65Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M95.66,108.7s-1.38-1.01-4.05-3.05c-2.67-2.04-6-4.57-7.61-5.65-2.53-1.69-3.35-.15-3.35-.15,0,0-2.25,3.91.45,6.73,1.94,2.03,4.84,3.58,8.55,5.09,2.19.89,4.6,1.81,5.99,2.1.91.19,1.17.02,1.36-.29.48-.78-1.33-4.76-1.33-4.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M95.45,108.55c-1.27,0-1.31,1.95-1.13,2.77.18.82.84,3.1,2.06,2.32,1.23-.78-.93-5.09-.93-5.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M101.53,102.35c-1.67-.67-2.15.26-2.45.67-.3.41-4.24,5.73-4.51,6.34-.64,1.44.41,5.67,2.42,4.11,2-1.56,5.02-8.96,5.09-9.59.07-.63.11-1.08-.56-1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M99.78,102.29c-.41.35.11,1.08.51,1.37.4.3,1.88,1.12,1.77.13-.12-.99-2.28-1.51-2.28-1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M104.17,99.31c-.93-1.17-1.04-.74-1.28-.65-.24.09-1.74.07-2.23.45s-.7.7-.89,1.32c-.19.61-.28,1.93.11,2.52.39.59,1.84,1.35,2.21.93.37-.43,2.65-1.95,2.65-1.95,0,0-.11-2.09-.57-2.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M104.96,95.64c-.32-.1-.71.79-.81.98-.09.19-1,1.38-1.14,1.59s-.04.97.44,1.11,1.49-1.94,1.59-2.19c.1-.25.6-1.31-.08-1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M105.86,96.86c-.18-.36-.5-.24-.5-.24,0,0-.51,1.21-.54,1.25-.03.05-.85,1.17-.92,1.45-.06.28-.1.76.29.74.39-.03,1.23-1.53,1.29-1.74.06-.21.49-.92.38-1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M105.99,98.28c-.02-.14-.13-.62-.19-.59-.06.03-1.14,2.12-1.32,2.34-.18.23.03.78.15.74.11-.03.82-.78.96-1.13.15-.35.41-1.36.41-1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M105.58,100.15c0-.12-.19-.47-.38-.2-.19.27-.5.7-.57.88-.07.18-.38.45-.39.62,0,.17,0,.53.09.52.09,0,.67-.27.87-.63.2-.36.38-1.18.38-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M101.64,98.81c-.29-.23-.36-.33-.33-.57.04-.25.47-1.87.33-2.27-.14-.41-.45-.82-.71-.63-.26.19-.43.88-.49,1.27-.06.4-.47,1.55-.43,2.09.04.54-.27,1.29-.21,1.67.06.38.74.22,1.3-.08.56-.3.58-1.53.58-1.53l-.03.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M76.47,91.09c.71-1.22,1.85-1.88,2.56-1.48l.55.32-.12.21c.23.6.09,1.53-.42,2.41-.51.88-1.25,1.47-1.89,1.58l-.13.22-.55-.32c-.71-.4-.71-1.72,0-2.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M77.01,91.4c-.71,1.22-.71,2.54,0,2.94.71.4,1.85-.26,2.56-1.48.71-1.22.71-2.54,0-2.94-.71-.4-1.85.26-2.56,1.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M77.35,91.59c-.52.9-.52,1.88,0,2.18.52.3,1.37-.19,1.9-1.1.52-.9.52-1.88,0-2.18-.52-.3-1.37.19-1.9,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M77.22,92.76c0,.68.48.96,1.08.61s1.08-1.17,1.08-1.86c0-.68-.48-.96-1.08-.61-.59.34-1.08,1.17-1.08,1.86Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "77.68 92.99 78.23 93.3 79.46 85.07 78.91 84.75 78.18 85.17 77.68 92.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "78.23 93.3 79.46 92.59 79.46 85.07 78.73 85.49 78.23 93.3"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "139.85 182.27 133.4 178.83 127.84 181.32 129.46 181.3 130.39 186.75 132.21 186.73 139.85 182.27"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "132.28 178.24 125.83 174.8 120.27 177.29 121.89 177.27 122.81 182.73 124.64 182.7 132.28 178.24"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "124.68 174.21 118.24 170.78 112.68 173.26 114.3 173.24 115.22 178.7 117.05 178.67 124.68 174.21"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "117.14 170.18 110.7 166.75 105.14 169.24 106.76 169.21 107.68 174.67 109.51 174.64 117.14 170.18"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "112.85 144.98 113.42 171.38 107.68 174.72 107.11 148.32 112.85 144.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "107.11 148.32 107.68 174.72 101.71 171.54 101.14 145.14 107.11 148.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "112.85 144.98 107.11 148.32 101.14 145.14 106.88 141.8 112.85 144.98"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "120.63 160.22 120.99 175.36 115.24 178.7 114.89 163.56 120.63 160.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "114.89 163.56 115.24 178.7 109.27 175.52 108.92 160.38 114.89 163.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "120.63 160.22 114.89 163.56 108.92 160.38 114.66 157.04 120.63 160.22"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "127.97 156.86 128.55 179.39 122.81 182.73 122.23 160.2 127.97 156.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "122.23 160.2 122.81 182.73 116.84 179.54 116.26 157.02 122.23 160.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "127.97 156.86 122.23 160.2 116.26 157.02 122 153.68 127.97 156.86"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "135.93 174.27 136.11 183.42 130.37 186.75 130.19 177.61 135.93 174.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "130.19 177.61 130.37 186.75 124.4 183.57 124.22 174.43 130.19 177.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "135.93 174.27 130.19 177.61 124.22 174.43 129.96 171.09 135.93 174.27"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "210.43 175.84 200.68 170.64 192.27 174.41 194.72 174.37 196.12 182.62 198.88 182.58 210.43 175.84"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "198.98 169.74 189.23 164.55 180.82 168.31 183.27 168.28 184.67 176.53 187.43 176.49 198.98 169.74"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "187.49 163.65 177.74 158.46 169.34 162.22 171.79 162.19 173.19 170.44 175.95 170.4 187.49 163.65"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "176.09 157.56 166.34 152.36 157.93 156.13 160.39 156.1 161.78 164.34 164.55 164.31 176.09 157.56"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "169.6 119.45 170.47 159.38 161.79 164.43 160.92 124.5 169.6 119.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "160.92 124.5 161.79 164.43 152.76 159.62 151.89 119.69 160.92 124.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "169.6 119.45 160.92 124.5 151.89 119.69 160.57 114.64 169.6 119.45"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "181.36 142.5 181.9 165.39 173.22 170.44 172.68 147.54 181.36 142.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "172.68 147.54 173.22 170.44 164.19 165.63 163.65 142.73 172.68 147.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "181.36 142.5 172.68 147.54 163.65 142.73 172.33 137.68 181.36 142.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "192.47 137.41 193.34 171.48 184.66 176.53 183.79 142.46 192.47 137.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "183.79 142.46 184.66 176.53 175.63 171.72 174.76 137.65 183.79 142.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "192.47 137.41 183.79 142.46 174.76 137.65 183.44 132.6 192.47 137.41"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "204.5 163.75 204.77 177.57 196.09 182.62 195.82 168.79 204.5 163.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "195.82 168.79 196.09 182.62 187.06 177.81 186.79 163.98 195.82 168.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "204.5 163.75 195.82 168.79 186.79 163.98 195.47 158.94 204.5 163.75"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01AiGuardrails);
export default __webpack_public_path__ + "static/media/01 AI Guardrails.ed11aa6be185a5b73f84da7bb84c213b.svg";
export { ForwardRef as ReactComponent };